import { DeckAPI } from '@philips-internal/oswald-ui-components';
import { EstablishmenSuggestions, ScheduleItem, SuggestionGroups, SuggestionItems } from '../../../interfaces/schedules-suggestions';

export default class PseudonymSuggestionListModel {

  decksSuggestionItems: Array<DeckAPI>;

  establishmentSuggestions: Array<EstablishmenSuggestions>;

  establishmentSuggestionsDefault: Array<EstablishmenSuggestions>;

  hasSelected: boolean;

  isShowPrice: boolean;

  lastDeckApi: DeckAPI | undefined;

  lastDeckApiSelected?: DeckAPI;

  numberTimesSchedulingDay: number;

  selectedItemList: Array<ScheduleItem>;

  suggestionGroup: SuggestionGroups;

  suggestionItemsSelected: Array<SuggestionItems>;

  wantToRequest: boolean;

  constructor(establishmentSuggestions: Array<EstablishmenSuggestions>, isShowPrice: boolean, numberTimesSchedulingDay: number, suggestionGroup: SuggestionGroups) {
    this.decksSuggestionItems = [] as Array<DeckAPI>;
    this.establishmentSuggestions = establishmentSuggestions;
    this.establishmentSuggestionsDefault = establishmentSuggestions;
    this.hasSelected = false;
    this.isShowPrice = isShowPrice;
    this.lastDeckApi = undefined;
    this.numberTimesSchedulingDay = numberTimesSchedulingDay;
    this.selectedItemList = [] as Array<ScheduleItem>;
    this.suggestionGroup = suggestionGroup;
    this.suggestionItemsSelected = [] as Array<SuggestionItems>;
    this.wantToRequest = false;
  }

}
